import { computed, nextTick, ref, watch } from 'vue';

export default function VueFormUploader() {
  return {
    apply: 'FilePreview',
    setup(props, context, component) {
      const is_name_editable = ref(false);
      const input_notes = ref('');
      const text_area_ref = ref(null);
      const file = computed(() => component.el$.value?.model || Object.values(component.el$.value.data)[0] || {});

      function initialize() {
        if (file.value && !file.value?.progress)
          file.value.progress = ref(0);

        if (file.value && !file.value?.error)
          file.value.error = ref(null);
      }

      watch(file, (new_val, old_val) => {
        if (!file.value?.progress)
          initialize();
      }, { immediate: true });

      watch(is_name_editable, async (newVal) => {
        if (newVal) {
          await nextTick();
          text_area_ref.value?.focus();
        }
      });

      const reupload = () => {
        component?.form$?.value?.uppy.retryUpload(file.value.uppy_id);
        file.value.error.value = null;
      };

      function updateNotesHandler(data) {
        if (file.value instanceof File) {
          file.value.notes = data.notes;
        }
        else {
          component.el$.value.update({ ...file.value, notes: data.notes });
        }
      }

      const progress = computed(() => file.value?.progress);
      const is_error = computed(() => file.value?.error);
      const is_uploading = computed(() => component?.form$?.value.uploading.value);
      const submitting = computed(() => component?.form$?.value?.busy);
      const download_file_url = url => url ? window.open(url, '_blank') : '';
      return {
        ...component,
        is_name_editable,
        input_notes,
        text_area_ref,
        file,
        progress,
        submitting,
        is_error,
        is_uploading,
        download_file_url,
        reupload,
        updateNotesHandler,
        numberToBytes(data) {
          const const_term = 1000;
          const bytes = data / const_term;

          if (!data)
            return '0KB';
          else if (bytes < const_term)
            return `${bytes.toFixed(2)}KB`;
          else if (bytes < const_term ** 2)
            return `${(data / const_term ** 2).toFixed(2)}MB`;
          else if (bytes < const_term ** 3)
            return `${(data / const_term ** 3).toFixed(2)}GB`;
          else if (bytes < const_term ** 4)
            return `${(data / const_term ** 4).toFixed(2)}TB`;
          else
            return 'Please pass valid option';
        },
      };
    },
  };
}
